export const colours = {
  primary: {
    light: {
      _5: "#F8F9FD",
      _10: "#F0F2FA",
      _15: "#EAECF6",
      _20: "#E4E6F2",
      _30: "#D7DAE9",
      _40: "#BEC3D8",
      _50: "#A5ABC7",
      _60: "#8C93B6",
      _70: "#737BA5",
    },
    mid: {
      light10: "#5A6494",
      light20: "#4E588C",
      mid: "#414C83",
      dark10: "#35407B",
      dark20: "#283472", // Brand color
    },
    dark: {
      _10: "#202A5B",
      _20: "#1C2550",
      _30: "#181F44",
      _40: "#141A39",
      _50: "#10152D",
      _60: "#0B0E1E",
    },
  },
  accent: {
    light: {
      _5: "#FDFDFB",
      _10: "#FCFBF8",
      _15: "#FAF9F4",
      _20: "#F4F3ED",
      _30: "#EDECE5",
      _40: "#E0DED6",
      _50: "#D3D1C7",
      _60: "#C7C4B7",
      _70: "#BAB7A8",
    },
    mid: {
      light10: "#ADA999",
      light20: "#A09C8A", // Brand color
      mid: "#908C7C",
      dark10: "#7F7C6D",
      dark15: "#757264",
      dark20: "#6B685B",
    },
    dark: {
      _10: "#5E5B50",
      _20: "#4E4B42",
      _30: "#3D3B33",
      _40: "#2D2B25",
      _50: "#22211C",
      _60: "#161612",
    },
  },
  success: {
    light: {
      _5: "#FBFEFC",
      _10: "#F7FDF8",
      _15: "#F3FCF4",
      _20: "#EEFBF0",
      _30: "#E4F9E7",
      _40: "#DAF6DD",
      _50: "#D0F4D4",
      _60: "#B2EDB7",
      _70: "#82E189",
    },
    mid: {
      light10: "#39D045",
      light20: "#2EB33B",
      mid: "#1F852C",
      dark10: "#1A7125",
      dark20: "#14591D",
    },
    dark: {
      _10: "#104E17",
      _20: "#0C4411",
      _30: "#08390C",
      _40: "#042F06",
      _50: "#002400",
      _60: "#001400",
    },
  },
  error: {
    light: {
      _5: "#FFF5F5",
      _10: "#FFEBEB",
      _15: "#FFE6E6",
      _20: "#FFE1E1",
      _30: "#FED7D7",
      _40: "#FECECD",
      _50: "#FEC4C3",
      _60: "#FEB0AF",
      _70: "#FD8886",
    },
    mid: {
      light10: "#F9504D",
      light20: "#EF2825",
      mid: "#E31C17",
      dark10: "#DB130E",
      dark20: "#CC0803",
    },
    dark: {
      _10: "#A60702",
      _20: "#7A0701",
      _30: "#650601",
      _40: "#510400",
      _50: "#3D0300",
      _60: "#290200",
    },
  },
  uIGrey: {
    light: {
      _5: "#FAFAFB",
      _10: "#F4F4F6",
      _15: "#EAEAEE",
      _20: "#E0E0E6",
      _30: "#C6C8D2",
      _40: "#B5B8C4",
      _50: "#A4A6B6",
      _60: "#9396A9",
      _70: "#83869B",
      _0: "#FFFFFF",
    },
    mid: {
      light_10: "#73778D",
      light_20: "#64687D",
      mid: "#494C5C",
      dark_5: "#464958",
      dark_10: "#3B3E4B",
      dark_20: "#2D2F39",
    },
    dark: {
      _10: "#202128",
      _20: "#1D1E24",
      _30: "#191A20",
      _40: "#16171C",
      _50: "#121317",
      _60: "#0E0E11",
      _70: "#09090B",
    },
  },
  highlight: {
    yellow: "#FFB300",
    apple: "#6EB200",
    orange: "#FF6000",
    peach: "#FF0D00",
    pink: "#E82177",
    purple: "#AD2DF2",
    violet: "#2839F9",
    blue: "#0179DC",
    teal: "#0ABE9D",
    green: "#00C033",
    darkYellow: "#463307",
    darkOrange: "#A33F00",
    darkPeach: "#B80900",
    darkPink: "#A61152",
    darkPurple: "#740BAD",
    darkViolet: "#040F8B",
    darkBlue: "#014E8E",
    darkTeal: "#067460",
    darkGreen: "#007A21",
    darkApple: "#4B7A00",
  },
  other: {
    greenBackground: "#C5E7CE",
  },
  bolt: "#FFD747",
};
